document.querySelectorAll('.solution__compress-pdf .solution__form').forEach((form) => {
    form.addEventListener('submit', function (event) {
        event.preventDefault();

        const formId = form.getAttribute('id');
        const fileInput = form.querySelector('[name="file"]');
        const dpiInput = form.querySelector('[name="dpi"]');
        const imageQualityInput = form.querySelector('[name="image-quality"]');

        const loadingSection = document.getElementById(
            `loadingSection_${formId}`
        );
        const errorSection = document.getElementById(
            `errorSection_${formId}`
        );
        const resultMessage = document.getElementById(
            `resultMessage_${formId}`
        );
        const downloadSection = document.getElementById(
            `downloadSection_${formId}`
        );

        // Hide the form, show the loading indicator, hide error and download sections
        form.style.display = 'none';
        loadingSection.style.display = 'flex';
        errorSection.style.display = 'none'; // Hide error section
        downloadSection.style.display = 'none';

        const formData = new FormData();
        Array.from(fileInput.files).forEach((file, index) => {
            formData.append(`file[${index}]`, file);
        });
        formData.append('dpi', dpiInput.value);
        formData.append('imageQuality', imageQualityInput.value);
        formData.append('compressPDFFormNonce', wpApiSettings.compressPDFNonce);

        fetch(`${wpApiSettings.root}compress-pdf/v1/send-data`, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.id) {
                    pollStatus(data.id, formId);
                } else {
                    loadingSection.style.display = 'none';
                    errorSection.style.display = 'flex';
                    resultMessage.innerText =
                        'An unexpected error occurred. Please try again.';
                }
            })
            .catch(() => {
                loadingSection.style.display = 'none';
                errorSection.style.display = 'flex';
                resultMessage.innerText =
                    'An unexpected error occurred. Please try again.';
            });
    });

    // Add event listener for restart buttons
    const restartDownloadBtn = document.getElementById(
        `restartDownloadBtn_${form.id}`
    );
    const restartErrorBtn = document.getElementById(
        `restartErrorBtn_${form.id}`
    );

    // Function to restart the process and reset the form
    function resetForm() {
        form.reset();
        form.style.display = 'flex';
        document.getElementById(`loadingSection_${form.id}`).style.display =
            'none'; // Hide loading
        document.getElementById(
            `downloadSection_${form.id}`
        ).style.display = 'none'; // Hide download
        document.getElementById(`errorSection_${form.id}`).style.display =
            'none'; // Hide error section
    }

    if (restartDownloadBtn) {
        restartDownloadBtn.addEventListener('click', resetForm);
    }

    if (restartErrorBtn) {
        restartErrorBtn.addEventListener('click', resetForm);
    }
});

document.querySelectorAll('.solution__compress-pdf .solution__range-linked').forEach((input) => {
    const min = input.getAttribute('min');
    const max = input.getAttribute('max');
    const value = input.value;

    ionRangeSlider(input, {
        min: min,
        max: max,
        from: value,
        step: 1,
        grid: true,
        grid_num: 5,
    });
})

function pollStatus(id, formId) {
    const loadingSection = document.getElementById(`loadingSection_${formId}`);
    const errorSection = document.getElementById(`errorSection_${formId}`);
    const resultMessage = document.getElementById(`resultMessage_${formId}`);
    const downloadSection = document.getElementById(`downloadSection_${formId}`);
    const downloadFilesContainer = document.getElementById(`downloadFilesContainer_${formId}`);

    function checkStatus() {
        fetch(`${wpApiSettings.root}compress-pdf/v1/status/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'done') {
                    loadingSection.style.display = 'none';
                    downloadFilesContainer.innerHTML = ''; // Clear previous downloads

                    if (data.output && data.output.files && data.output.files.length > 0) {
                        data.output.files.forEach(file => {

                            // Create download button
                            const downloadButton = document.createElement('button');
                            downloadButton.type = 'button';
                            downloadButton.className = 'solution__btn';
                            downloadButton.innerHTML = `
                                <div class="dashicons dashicons-download"></div>
                                <span class="solution__download-file-name">${file.name}</span>
                            `;

                            // Set download functionality
                            downloadButton.addEventListener('click', (event) => {
                                event.preventDefault();
                                const anchor = document.createElement('a');
                                anchor.href = file.path;
                                anchor.target = '_blank';
                                document.body.appendChild(anchor);
                                anchor.click();
                                document.body.removeChild(anchor);
                            });

                            // Append elements to the container
                            const fileContainer = document.createElement('div');
                            fileContainer.className = 'solution__download-file-container'
                            fileContainer.appendChild(downloadButton);
                            downloadFilesContainer.appendChild(fileContainer);
                        });

                        downloadSection.style.display = 'flex'; // Show download section
                    } else {
                        errorSection.style.display = 'flex';
                        resultMessage.innerText = 'No files available for download.';
                    }
                } else if (data.status === 'error') {
                    throw new Error('Processing failed: ' + data.message);
                } else {
                    setTimeout(checkStatus, 500);
                }
            })
            .catch(() => {
                loadingSection.style.display = 'none';
                errorSection.style.display = 'flex';
                resultMessage.innerText = 'An unexpected error occurred. Please try again.';
            });
    }
    checkStatus();
}
